import { render, staticRenderFns } from "./DeletePrompt.vue?vue&type=template&id=133bf4aa&scoped=true&"
import script from "./DeletePrompt.vue?vue&type=script&lang=js&"
export * from "./DeletePrompt.vue?vue&type=script&lang=js&"
import style0 from "./DeletePrompt.vue?vue&type=style&index=0&id=133bf4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133bf4aa",
  null
  
)

export default component.exports